import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepComponent } from '../step/step.component';
import { AnswersStore } from 'src/app/store/answers-store';
import { GlobalStore } from 'src/app/store/global-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { environment } from 'src/environment';
import { DragStore } from 'src/app/store/drag-store';

@Component({
    selector: 'que-stepper',
    imports: [CommonModule, StepComponent],
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent {
  @Input()
  isPreview = false;
  @Input()
  isData = false;
  @Input()
  currentStep?: number;
  @Input()
  stepsNames: (string | undefined)[] = [];
  @Output()
  ChangeStepEvent = new EventEmitter(); #dragStore = inject(DragStore);
  #answersStore = inject(AnswersStore);
 
  addingStepNow$ = this.#dragStore.addingStepNow$;
 


  changePage(i: number) {
    this.ChangeStepEvent.emit(i);
    this.#answersStore.updateVisitedSteps(this.currentStep!);
    this.#dragStore.goToTop(true);
  }

}
